export const REFERENCE_ENTRY = '/';
export const PARCELS = '/parcels';
export const PARCEL = '/parcels/:parcelId';
export const SEARCH = '/search';
export const ERROR = '/error';
